import * as React from "react";

interface Props {
    color: string;
    size?: number;
}

export const Connections = (props: Props) => {
    const size = props.size ?? 24;

    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.6875 9.81818C13.6875 9.36631 13.3237 9 12.875 9H12.4688C10.0007 9 8 11.0147 8 13.5C8 15.9853 10.0007 18 12.4688 18H16.5312C18.9993 18 21 15.9853 21 13.5C21 11.462 19.6546 9.74036 17.8093 9.18673C17.3517 9.04943 16.9375 9.43271 16.9375 9.91358V9.95588C16.9375 10.363 17.2418 10.6965 17.6155 10.8519C18.6482 11.2811 19.375 12.305 19.375 13.5C19.375 15.0815 18.1018 16.3636 16.5312 16.3636H12.4688C10.8982 16.3636 9.625 15.0815 9.625 13.5C9.625 11.9185 10.8982 10.6364 12.4688 10.6364H12.875C13.3237 10.6364 13.6875 10.2701 13.6875 9.81818Z"
                fill={props.color}
            />
            <path
                d="M11.5312 5C13.9993 5 16 7.01472 16 9.5C16 11.9853 13.9993 14 11.5312 14H11.125C10.6763 14 10.3125 13.6337 10.3125 13.1818C10.3125 12.7299 10.6763 12.3636 11.125 12.3636H11.5312C13.1018 12.3636 14.375 11.0815 14.375 9.5C14.375 7.91845 13.1018 6.63636 11.5312 6.63636H7.46875C5.89819 6.63636 4.625 7.91845 4.625 9.5C4.625 10.695 5.35179 11.7189 6.38449 12.1481C6.7582 12.3034 7.0625 12.637 7.0625 13.0441V13.0864C7.0625 13.5673 6.64832 13.9506 6.19068 13.8133C4.34544 13.2596 3 11.538 3 9.5C3 7.01472 5.00072 5 7.46875 5H11.5312Z"
                fill={props.color}
            />
        </svg>
    );
};
